module.exports = __webpack_public_path__ + "img/icon4.a1979a8b.png";